export const SESSION_MENU_TEST_IDS = {
  menuButton: "session-menu-button",
  saveProgress: "session-menu-save-progress",
  restartInterview: "session-menu-restart",
  restartConfirmModal: "session-menu-restart-confirm-modal",
  restartConfirmButton: "session-menu-restart-confirm",
  restartCancelButton: "session-menu-restart-cancel",
  emailModal: "session-menu-email-modal",
};
